import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';
import { finalize } from 'rxjs';
import { CreatorLibraryService, ItemSummary } from '../../../services/creator-library.service';

/**
 * Creator › Bibliothek › Umbenennen: a new title for one piece of content
 * (`PATCH /creator/items/{id}` with the lock, CreatorLibraryService.rename).
 * For E-Learning and Microlearning the server renames the course as well, so
 * editor, package and library show the same name.
 */
@Component({
  selector: 'app-creator-rename-dialog',
  templateUrl: './creator-rename-dialog.component.html',
  styleUrl: './creator-rename-dialog.component.scss',
})
export class CreatorRenameDialogComponent implements OnInit {
  item!: ItemSummary;
  onRenamed: () => void = () => undefined;

  readonly name = new FormControl('', { nonNullable: true, validators: [Validators.required, Validators.maxLength(255)] });
  working = false;

  constructor(
    private ref: NbDialogRef<CreatorRenameDialogComponent>,
    private library: CreatorLibraryService,
    private toastr: NbToastrService,
    private t: TranslateService,
  ) {}

  ngOnInit(): void {
    this.name.setValue(this.item.title);
  }

  cancel(): void {
    this.ref.close();
  }

  submit(): void {
    const title = this.name.value.trim();
    if (!title) this.name.setValue('');
    this.name.markAllAsTouched();
    if (this.name.invalid || this.working) return;
    if (title === this.item.title) return this.ref.close();
    this.working = true;
    this.library
      .rename(this.item.id, title)
      .pipe(finalize(() => (this.working = false)))
      .subscribe({
        next: (r) => {
          this.toastr.success(this.t.instant('pages.creator.rename.done', { title: r.title }), '');
          this.onRenamed();
          this.ref.close();
        },
        error: (err) => {
          const by = err?.error?.by?.name;
          const key = err?.error?.error === 'locked' && by ? 'pages.creator.rename.locked' : 'pages.creator.rename.failed';
          this.toastr.danger(this.t.instant(key, { name: by }), '');
        },
      });
  }
}
